// Component Name:  ChargerDetails component
// Author: Bharath
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Reference: AddLocation
// Date:
// Description: This component is to view the selected charger details,
// remote start, end the charger transaction, view transaction and fault logs
// and also to edit the charger details(UnitPrice and location).
// Dependencies: React,  Redux , API layer to fetch and add both charger and location
// Interfaces: Accepts props including selectedChargerId,locationData,user, toast messages
// Maintenance History:  1.0 - First Version

// Edited by Lavanya S
// [23-04-2025] Integrated IdTag Modal to accept the idTag/RFID before initiating remote charger start.
// [23-04-2025] Integrated toast messages.
// [25-04-2025] Integrated API layer and enabled edit charger, allowing user to select the location and customize the unit price.
// [22-04-2025] Updated to display charger details including serial number, model type, number of connectors, and charger address.
// [22-04- 2025]
import React, { Component, useState } from "react";
import {
  Container,
  Card,
  CardBody,
  UncontrolledAlert,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
  Media,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  Alert,
  Label,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import classnames from "classnames";
import ReactModal from "react-modal";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import MiniWidgets from "../Dashboard/MiniWidgets";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//Import Product Images
import img1 from "../../assets/images/product/img-1.png";
import img5 from "../../assets/images/product/img-5.png";
import img3 from "../../assets/images/product/img-3.png";
import img4 from "../../assets/images/product/img-4.png";
import lev from "../../assets/images/product/Picture2.jpg";
import ac06 from "../../assets/images/product/Picture1.jpg";
import ac06m from "../../assets/images/product/cfac06m.png";

import io from "socket.io-client";
import { connect } from "react-redux";
import { linkify_fault_log } from "../../helpers/wiki_linker";
import { isTechnician } from "../Authentication/userMetaData";
import { getRequestTopic, getResponseTopic } from "../../helpers/topic_Management";
import { lkprimary } from "../Dashboard/styles";
import { getRecentTransaction, getTransaction } from "../../api/transactionAPI";
import { getRecentStatus, getStatus } from "../../api/statusAPI";
import { addCharger, getCharger, getChargerById } from "../../api/chargerAPI";
import { CURRENCY_MAP, LATEST_FAULT_LOG_COLUMN_DATA, LATEST_TRANSACTION_LOG_COLUMN_DATA, VENDOR_ID } from "../Utility/Constants";
import { computeConsumption, computeDate, computePaymentStatus, computeTime, computeTotal, inputRequired } from "../Utility/utilsFunctions";
import { failureToast, warningToast } from "../../store/dbFilter/actions";
import { getLocationById } from "../../api/locationAPI";
import { modalStyle } from "../Utility/styleComponents";
import { loadImages } from "../../api/utils/loadImages";
import { loadTransactions } from "../../api/utils/loadTransactions";
import { loadLocation } from "../../api/utils/loadLocations";
import { locationData } from "../Dashboard/dbConstants";
import LKSettingImg from "../../assets/images/LK_Icons/LK_Settings.svg";
import LKRefreshImg from "../../assets/images/LK_Icons/LK__Refresh.svg";
import LKFileImg from "../../assets/images/LK_Icons/LK_File.svg";
import LKCloseImg from "../../assets/images/LK_Icons/LK_Close.svg";

import { ActiveBtn, CancelBtn } from "../Utility/Button";

let socket;
let location = {
  name: "",
  lat: "12.9843873",
  lng: "77.7420796",
  address: "",
};

let chargerId_1 = "C4EC8F1B5AE0";
let chargerId_2 = "B401991B5AE0";
let chargerId_3 = "944A4CEF49C0";
let chargerId_4 = "80C606144B8C";

/* let chargerId_1 = "6076A1ACCD98";
let chargerId_2 = "F8474CEF49C0";
let chargerId_3 = "20898795AB34"; */

// let chargerId_1 = "1CB705144B8C";
// //let chargerId_2 = "2C484CEF49C0";
// let chargerId_2 = "D8478F0C8598";
// let chargerId_3 = "3C1E06144B8C";

let firmwareUpgradeURL = "";

//const rating = "7.2";

const expandRow = {
  renderer: (row) => (
    <>
      Action :
      <Link to="#" className="mr-3 text-primary">
        <i className="mdi mdi-pencil font-size-18"></i>
      </Link>
      <Link to="#" className="text-danger">
        <i className="mdi mdi-trash-can font-size-18"></i>
      </Link>
    </>
  ),

  showExpandColumn: true,
  expandByColumnOnly: true,
};

class ChargerDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Charger Management System", link: "#" },
        { title: "Charger Details", link: "#" },
      ],
      activeTab: "1",
      activeTab2: "1",
      chargerStatus: "Offline",
      start_btn_clr: lkprimary,
      stop_btn_clr: "#EFF2F7",
      start_btn_txt_clr: "#ffffff",
      stop_btn_txt_clr: "#000000",
      chargerId: props.selectedChargerId || null,
      transLog: [],
      faultLog: [],
      reservationHistory: [],
      chargerDetails: {},
      consumption: "0",
      ActiveTransactionId: 0,
      ocppId: "",
      syncIntervalId: "",
      imgSrc: lev,
      rating: "7.4",
      imageMap: {},
      lasthb: "",
      perUnitRate: 0,
      currency: "₹",
      protocol: "Ocpp1.6",
      connectors: "",
      address: "",
      serialNumber: "",
      modelType: "",
      noOfConnectors: 0,
      firmwareVersion: "",
      showAlert: false,
      firmwareUrl: "",
      alertMessage: "",
      startDisable: false,
      stopDisable: false,
      user: props.user,
      isShowIdTagModal: false,
      idTag: "",
      locationId: "",
      selectedPerUnitRate: 0,
      hostId: "",
      initialLocationDetails: {
        id: "",
        lat: "",
        lng: "",
        address: "",
      },
      selectedLocationDetails: {
        id: "",
        lat: "",
        lng: "",
        address: "",
        perUnitRate: 0,
      },
      locationData: [],
    };
    this.toggleTab = this.toggleTab.bind(this);
    this.toggleTab2 = this.toggleTab2.bind(this);
    this.imageShow = this.imageShow.bind(this);
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  toggleTab2(tab) {
    if (this.state.activeTab2 !== tab) {
      this.setState({
        activeTab2: tab,
      });
    }
  }

  toggleChargeButtons = (chargerStatus) => {
    if (chargerStatus == null) return;

    if (chargerStatus === "Charging") {
      this.setState({
        start_btn_clr: "#EFF2F7",
        stop_btn_clr: "#FF3D60",
        start_btn_txt_clr: "#000000",
        stop_btn_txt_clr: "#ffffff",
      });
    } else {
      this.setState({
        start_btn_clr: "#5664D2",
        stop_btn_clr: "#EFF2F7",
        start_btn_txt_clr: "#ffffff",
        stop_btn_txt_clr: "#000000",
      });
    }
  };

  imageShow(img, id) {
    var expandImg = document.getElementById("expandedImg" + id);
    expandImg.src = lev;
  }

  updateChargerImage = () => {
    let src = ac06;

    if (this.state.chargerId === null) src = ac06;

    if (this.state.chargerId === chargerId_1) src = ac06;
    //src = lev;

    if (this.state.chargerId === chargerId_2) src = lev;

    if (this.state.chargerId === chargerId_3) src = ac06;
    //src = lev;

    this.setState({ imgSrc: src });
  };

  updateChargerContent = () => {
    let rating = "7.4kW";
    let protocol = "OCPP1.6";
    let ocppId = "";
    if (this.state.chargerId === null) rating = null;

    if (this.state.chargerId === chargerId_1) rating = "7.4kW";
    //src = lev;

    if (this.state.chargerId === chargerId_2) {
      rating = "3.3kW";
      protocol = "BLE (LevAC)";
      ocppId = "NA";
    }

    if (this.state.chargerId === chargerId_3) rating = "22kW";
    if (this.state.chargerId === chargerId_4) rating = "7.4kW";

    this.setState({ rating, protocol, ocppId });
  };

  renderStatus = () => {
    if (this.state.chargerStatus === "Charging") {
      //return "mr-2 text-success";

      return "p-2 mr-2 text-white bg-success rounded";
    }
    if (this.state.chargerStatus === "Available") return "mr-2 text-success";
    //return "p-1 mr-2 text-white bg-primary rounded";

    if (this.state.chargerStatus === "Preparing") return "mr-2 text-warning";
    //return "p-1 mr-2 text-white bg-warning rounded";
    if (this.state.chargerStatus === "Faulted")
      // return "mr-2 text-danger";
      return "p-2 mr-2 text-white bg-danger rounded";
    if (this.state.chargerStatus === "Finishing") return "mr-2 text-warning";

    if (this.state.chargerStatus === "Offline") return "mr-2 text-danger";

    if (this.state.chargerStatus === "Reserved") return "mr-2 text-primary text-white rounded";

    //return "p-1 mr-2 text-white bg-warning rounded";

    //return "mr-2 text-info";
    return "p-1 mr-2 text-white bg-info rounded";
  };

  socketSend = (topic, payload) => {
    console.log("socketSend: ", topic, payload);

    if (topic == null) return;

    if (payload == null) return;

    if (topic.toString().length <= 0 || payload.toString().length <= 0) return;

    if (socket == null) return;

    if (!socket.active) return;

    socket.emit("publish", JSON.stringify({ topic, payload }));
    // socket.timeout(3000).emit("publish", JSON.stringify({ topic, payload }), (err, response) => {
    //   if (err) {
    //     // the other side did not acknowledge the event in the given delay
    //     console.log("err socket: ",err); // "got it"

    //   } else {
    //     console.log("response: ",response); // "got it"
    //   }
    // });
  };

  msgSubscribe = (topic) => {
    if (socket == null) return;

    if (!socket.active) return;

    socket.emit("subscribe", { topic: getResponseTopic(this.state.chargerId) });
  };

  processMsg = (data) => {
    try {
      if (data == null) return;

      if (data.type == null) return;

      switch (data.type) {
        case "startResponse": {
          if (data.transactionId) this.setState({ ActiveTransactionId: data.transactionId });
          break;
        }

        case "stopResponse": {
          if (data.transactionId == this.state.ActiveTransactionId) this.setState({ ActiveTransactionId: 0 });
          break;
        }

        case "statusLog": {
          if (!data.status) return;

          if (data.status === this.state.chargerStatus) return;

          this.toggleChargeButtons(data.status);
          this.setState({ chargerStatus: data.status });

          break;
        }

        case "meterValue": {
          if (data.energy) this.setState({ consumption: data.energy / 1000 });

          break;
        }

        case "firmwareUpdateResponse": {
          if (data.status) {
            console.log("firnwareUpdate Response", data.status);
            this.setState({
              alertMessage: data.status,
              showAlert: true,
            });
          }

          break;
        }

        default:
          break;
      }
    } catch (e) {
      console.log("Charger Details Process Message Error", e.toString());
    }
  };
  // function fetches the location details based on location Id provided
  // if success, updates the selectedLocationDetails and return the value(this is to store the initial details)
  // on failure, shows err toasts
  fetchLocationData = async (locationId) => {
    try {
      const resData = await getLocationById(locationId);
      this.setState({
        selectedLocationDetails: {
          id: locationId,
          lat: resData?.latitude,
          lng: resData?.longitude,
          address: resData?.address,
        },
      });
      return { id: locationId, lat: resData?.latitude, lng: resData?.longitude, address: resData?.address };
    } catch (err) {
      console.log("Error getting the Location", err.msg);
    }
  };
  // to load all the images for the charger
  handleLoadImages = async (chargerData) => {
    const imagesdata = await loadImages(chargerData);
    console.log("imagesdata: ", imagesdata);

    this.setState({ imageMap: imagesdata });
  };
  /**
   * Makes a call to get the chargers
   * @param {string} id - charger id
   * @returns - returns chargerdata
   */
  handleGetCharger = async (chargerId) => {
    // console.log("chargerIds: ", chargerIds);

    try {
      const data = await getChargerById(chargerId);
      console.log("response chargerId: ", data);
      // const lasthb = response?.data?.lastHeartbeat;
      const { rating, currency, perUnitRate, protocolType, connectors, ocppId, locationId, hostId, modelType, serialNumber, lasthb, firmwareVersion } = data;

      const { id, lat, lng, address } = await this.fetchLocationData(locationId);
      this.handleLoadImages([data]);
      this.setState({
        chargerDetails: data,
        rating: rating,
        // lasthb: computeDate(lasthb) + " " + computeTime(lasthb),
        currency: this.getCurrencySymbol(currency),
        perUnitRate: perUnitRate,
        protocol: protocolType,
        connectors: this.getConnectorDetails(connectors),
        noOfConnectors: connectors?.length,
        // firmwareVersion: response?.data?.firmwareVersion,
        ocppId: ocppId,
        locationId: locationId,
        hostId: hostId,
        selectedPerUnitRate: perUnitRate,
        serialNumber: serialNumber,
        lasthb: computeDate(lasthb) + " " + computeTime(lasthb),
        firmwareVersion: firmwareVersion,
        modelType: modelType,
        initialLocationDetails: { id, lat, lng, address },
      });
    } catch (err) {
      console.log("Error getting the chargersData: ", err.msg);
    }
    // get charger details from the backend.iqlabs.io
    try {
      const response = await getCharger(chargerId);
      const { message, data } = response;
      if (data?.length === 0) {
        console.log("There are no chargers ");
        return;
      }
      console.log(`${message}`, data);

      const resdata = data[0];

      const lasthb = resdata.lastHeartbeat;

      const firmwareVersion = resdata.firmwareVersion;

      this.setState({
        lasthb: computeDate(lasthb) + " " + computeTime(lasthb),

        firmwareVersion: firmwareVersion,
      });
    } catch (err) {
      if (err.isErr) {
        console.log("Error getting the chargers: ", err.msg);
        console.log("Problem: ", err.problem);
        alert(err.msg);
      } else {
        console.log("Unexpected Error: ", err);
        alert(err);
      }
      return err;
    }
  };

  async componentDidMount() {
    ReactModal.setAppElement("#root");
    /* if (this.props.selectedChargerId != null) {
            if (this.state.chargerId !== this.props.selectedChargerId) {
                this.setState({ chargerId: this.props.selectedChargerId, transLog: [] });


                console.log("Update ChargerId", this.state.chargerId);
            }
        } */
    try {
      // await this.updateChargerDetails(this.state.chargerId);
      await this.handleGetCharger(this.state.chargerId);

      const charger_status = await this.updateChargerRecentStatus(this.state.chargerId);

      //const latest_transaction_id = await this.getLatestTransactionId(this.state.chargerId);
      //console.log("Latest Transaction Id", latest_transaction_id);

      if (charger_status != null) {
        if (charger_status !== this.state.chargerStatus) {
          const latest_transaction_id = await this.getLatestTransactionId(this.state.chargerId);
          this.toggleChargeButtons(charger_status);

          this.setState({
            chargerStatus: charger_status,
            ActiveTransactionId: latest_transaction_id,
          });
        }

        const latest_transaction_id = await this.getLatestTransactionId(this.state.chargerId);
      }

      await this.updateChargerTransLog(this.state.chargerId);
      await this.updateChargerFaultLog(this.state.chargerId);

      isTechnician(this.state.user) ? this.toggleTab2("2") : this.toggleTab2("1");
    } catch (e) {
      console.log("Charger Details Update Error", e.toString());
    }

    try {
      const data = await loadLocation(this.props.locationIds);
      this.setState({ locationData: data });
    } catch (e) {
      console.log("Error Images Data: ", e);
    }

    const intervalId = setInterval(async () => {
      try {
        //console.log("Charger Update Routine");
        await this.updateChargerTransLog(this.state.chargerId);
        await this.updateChargerFaultLog(this.state.chargerId);
      } catch (e) {
        console.log("Charger Details Update Error", e.toString());
      }
    }, 5000);

    this.setState({ syncIntervalId: intervalId });

    socket = io("https://backend.iqlabs.io:3000");

    socket.on("connect", () => {
      console.log("Socket Connection Successful");

      //console.log("Response Topic", this.getResponseTopic(this.state.chargerId))

      socket.emit("subscribe", JSON.stringify({ topic: getResponseTopic(this.state.chargerId) }));

      socket.on("mqtt", (msg) => {
        if (msg == null) return;

        //console.log("Rx Msg", msg);
        const msgJson = JSON.parse(msg);
        const topic = msgJson.topic;
        const payload = JSON.parse(msgJson.payload);
        console.log("Rx Msg Payload", payload);
        this.processMsg(payload);
      });
    });

    this.updateChargerImage();
    // this.updateChargerContent();
  }

  async componentWillUnmount() {
    //console.log("Charger Page Exited");
    clearInterval(this.state.syncIntervalId);

    if (socket) {
      // socket.emit(
      //   "unsubscribe",
      //   JSON.stringify({ topic: getResponseTopic(this.state.chargerId) })
      // );

      socket.disconnect();
    }

    this.setState({
      transLog: [],
      consumption: "Syncing...",
      ActiveTransactionId: 0,
    });
  }

  updateChargerRecentStatus = async (chargerId) => {
    if (chargerId == null) return;
    try {
      const response = await getRecentStatus(chargerId);
      const { message, data } = response;
      console.log(`${message}`, data);
      if (data.length <= 0) return;
      return data.at(0).status;
    } catch (err) {
      console.log("Error getting recent status", err.msg);
    }
  };

  getLatestTransactionId = async (chargerId) => {
    if (chargerId == null) return;
    try {
      const response = await getRecentTransaction(chargerId);
      console.log("response: ", response);
      const { message, data } = response;
      console.log(`${message}`, data);

      if (data?.length === 0) {
        console.log("There are no Recent Transaction ");
        return;
      }

      return data.at(0).transactionId;
    } catch (err) {
      console.log("Error deleting the Transaction ", err.msg);
    }
  };

  // updateChargerDetails = async (chargerId) => {
  //   if (chargerId == null) return;
  //   try {
  //     const response = await getCharger(chargerId);
  //     const { message, data } = response;
  //     if (data?.length === 0) {
  //       console.log("There are no chargers ");
  //       return;
  //     }
  //     console.log(`${message}`, data);

  //     const resdata = data[0];

  //     let updatedChgVals = {};

  //     const rating = chargerId === chargerId_2 ? "3.3kW" : resdata.rating;
  //     const lasthb = resdata.lastHeartbeat;
  //     const currency = resdata.currency;
  //     const perUnitRate = resdata.perUnitRate;
  //     const protocol = resdata.protocolType;
  //     const connectors = resdata.connectors;
  //     const firmwareVersion = resdata.firmwareVersion;
  //     let ocppId = "";

  //     if (resdata.ocppConnections[0].ocppId) ocppId = resdata.ocppConnections[0].ocppId;

  //     this.setState({
  //       rating: rating,
  //       lasthb: computeDate(lasthb) + " " + computeTime(lasthb),
  //       currency: this.getCurrencySymbol(currency),
  //       perUnitRate: perUnitRate,
  //       protocol: protocol,
  //       connectors: this.getConnectorDetails(connectors),
  //       firmwareVersion: firmwareVersion,
  //       ocppId: ocppId,
  //     });
  //   } catch (err) {
  //     if (err.isErr) {
  //       console.log("Error getting the chargers: ", err.msg);
  //       console.log("Problem: ", err.problem);
  //       // alert(err.msg);
  //       this.props.failureToast({ title: err.problem || "Error", message: err.msg || "Unexpected Error" });
  //     } else {
  //       console.log("Unexpected Error: ", err);
  //       // alert(err);
  //       this.props.failureToast({ title: "Error", message: "Unexpected Error" });
  //     }
  //     return err;
  //   }
  // };

  getConnectorDetails = (connectors) => {
    if (connectors == null) return "";

    if (connectors.length <= 0) return "";

    let connDetails = "";

    if (connectors.length == 1) connDetails = "Single-gun : ";
    else if (connectors.length == 2) connDetails = "Dual-gun : ";
    else connDetails = "Muli-gun : ";

    connectors.forEach((conn) => {
      connDetails += conn.connectorType + "; ";
    });

    return connDetails;
  };

  getCurrencySymbol = (currency) => {
    if (currency == null) return "";

    switch (currency.toLowerCase()) {
      case "rupee":
        return "₹";

      case "usd":
        return "$";

      case "pound":
        return "£";

      default:
        return currency;
    }
  };

  updateChargerTransLog = async (chargerId) => {
    if (chargerId == null) return;
    try {
      const response = await loadTransactions([chargerId]);
      const data = response;
      let i = 0,
        trans_data = [];
      data.forEach((item) => {
        trans_data.push({
          id: ++i,
          conn: item.connectorId,
          orderId: (
            <Link to="cms-charger-detail" className="text-dark font-weight-bold">
              {item.chargerId}
            </Link>
          ),
          date: computeDate(item.startTime) + ", " + computeTime(item.startTime),
          billingName: item.userId,
          total: computeTotal(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10), item.perUnitRate),
          consumption: computeConsumption(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
          status: computePaymentStatus(parseInt(item.meterStart, 10), parseInt(item.meterStop, 10)),
          transactionId: item.transactionId,
        });
      });

      if (JSON.stringify(trans_data) === JSON.stringify(this.state.transLog)) return;
      this.setState({ transLog: trans_data });
    } catch (err) {
      if (err.isErr) {
        console.log("Error getting the chargers: ", err.msg);
        console.log("Problem: ", err.problem);
        // alert(err.msg);
        this.props.failureToast({ title: err.problem || "Error", message: err.msg || "Unexpected Error" });
      } else {
        console.log("Unexpected Error: ", err);
        // alert(err);
        this.props.failureToast({ title: "Error", message: "Unexpected Error" });
      }
      return err;
    }
  };

  updateChargerFaultLog = async (chargerId) => {
    if (chargerId == null) return;
    try {
      const response = await getStatus(chargerId, "Faulted");
      const { message, data } = response;
      console.log(`${message}`, data);
      data.sort((a, b) => -a.timeStamp.localeCompare(b.timeStamp));
      let fault_data = [];
      let i = 0;
      data.forEach((item) => {
        fault_data.push({
          id: ++i,
          connId: item.connectorId,
          chargerId: item.chargerId,
          timeStamp: computeDate(item.timeStamp) + " " + computeTime(item.timeStamp),
          details: this.linkifyFaultLog(item.details),
        });
      });

      if (JSON.stringify(fault_data) === JSON.stringify(this.state.faultLog)) return;
      this.setState({ faultLog: fault_data });
    } catch (err) {
      if (err.isErr) {
        console.log("Error getting the chargers: ", err.msg);
        console.log("Problem: ", err.problem);
        // alert(err.msg);
        this.props.failureToast({ title: err.problem || "Error", message: err.msg || "Unexpected Error" });
      } else {
        console.log("Unexpected Error: ", err);
        // alert(err);
        this.props.failureToast({ title: "Error", message: "Unexpected Error" });
      }
      return err;
    }
  };

  firmwareInputChange = (event) => {
    if (!event) return;

    if (!event.target.value) return;

    firmwareUpgradeURL = event.target.value;
  };

  linkifyFaultLog = (faultDetail) => {
    if (!faultDetail) return;

    if (faultDetail.indexOf("ESBPressed") !== -1)
      return (
        <Link to={{ pathname: "http://localhost:8800/doku.php?id=esbpressed" }} target="_blank" className="text-primary font-weight-bold" style={{ color: "	#0000FF" }}>
          {faultDetail}
        </Link>
      );

    return faultDetail;
  };

  renderAlertMessage = (msg) => {
    if (!msg) return;

    switch (msg) {
      case "Installed": {
        return <UncontrolledAlert color="success">Installation Successful!</UncontrolledAlert>;
      }

      case "Downloaded": {
        return <UncontrolledAlert color="primary">Download done!</UncontrolledAlert>;
      }

      case "DownloadFailed": {
        return <UncontrolledAlert color="danger">Download failed!</UncontrolledAlert>;
      }

      case "Downloading": {
        return <UncontrolledAlert color="warning">Downloading...</UncontrolledAlert>;
      }

      case "InstallationFailed": {
        return <UncontrolledAlert color="danger">Installation Failed</UncontrolledAlert>;
      }

      case "Installing": {
        return <UncontrolledAlert color="primary">Installing...</UncontrolledAlert>;
      }

      default:
        break;
    }
  };

  firmware_upgrade_click = () => {
    if (!firmwareUpgradeURL) return;

    if (firmwareUpgradeURL.length == 0) return;

    this.socketSend(getRequestTopic(this.state.chargerId), {
      type: "firmwareUpdate",
      location: firmwareUpgradeURL,
    });
  };

  // reset the Id tag modal
  closeIsShowIdTagModal = () => {
    this.setState({ isShowIdTagModal: false });
  };

  // validates the idTag entered by the user and sends socket request for remote start transaction
  handleIdTag = () => {
    const idTagFormat = /^[a-zA-Z0-9]{8,16}$/i;
    if (!idTagFormat.test(this.state.idTag)) {
      this.props.warningToast({ title: "Id Tag", message: "Enter a valid Id tag" });
      return;
    }
    if (this.state.chargerStatus === "Offline") {
      this.props.warningToast({ title: "Warning", message: "Charger is Offline" });
      return;
    }
    if (this.state.chargerStatus !== "Charging") {
      this.setState({ isShowIdTagModal: false, startDisable: true });
      console.log("this.state.idtag ;", this.state.idTag);

      // this.setState({startDisable: true  });
      /* console.log("Socket Send Topic", this.getRequestTopic(this.state.chargerId));
                console.log("Socket Send Payload", JSON.stringify({
                    type: "remoteStart",
                    idTag: "9902062209",
                    connectorId: 1
                })); */
      const data = this.socketSend(getRequestTopic(this.state.chargerId), {
        type: "remoteStart",
        idTag: this.state.idTag,
        connectorId: 1,
      });
      console.log("data: ", data);
    }
  };

  // on location change fetches the selected location details and updateds
  updateLocationDetails = (e) => {
    this.fetchLocationData(e.target.value);
  };

  // On clicking "Update Charger Details":
  // - Checks whether `locationId` or `unitPrice` has been modified.
  // - If no changes are detected, shows a warning message.
  // - If values are updated, sends the update request, updates state values, and closes the modal.
  // - On failure, displays an error message.
  updateChargersUnitAndLocationId = async () => {
    const { locationId, selectedLocationDetails, selectedPerUnitRate, perUnitRate } = this.state;
    if (locationId === selectedLocationDetails?.id && selectedPerUnitRate === perUnitRate) {
      this.props.warningToast({ title: "Warning", message: "No Changes to Update" });
      return;
    }
    try {
      const updatedChargerDetails = {
        ...this.state.chargerDetails,
        locationId: this.state.selectedLocationDetails?.id,
        perUnitRate: this.state.selectedPerUnitRate,
      };
      console.log("updatedChargerDetails: ", updatedChargerDetails);
      await addCharger(updatedChargerDetails);
      this.setState({
        locationId: this.state.selectedLocationDetails?.id,
        initialLocationDetails: selectedLocationDetails,
        perUnitRate: this.state.selectedPerUnitRate,
        modal_static: false,
      });
    } catch (err) {
      console.log("Error updating chargers: ", err.msg);
    }
  };

  // On close edit charger, reset all the selected details to the previous values and closes the modal
  closeEditChargerModal = () => {
    this.setState({ selectedLocationDetails: this.state.initialLocationDetails, selectedPerUnitRate: this.state.perUnitRate, modal_static: false });
  };
  render() {
    const options = {
      // pageStartIndex: 0,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: false,
      sizePerPageList: [
        {
          text: "5th",
          value: 5,
        },
        {
          text: "10th",
          value: 10,
        },
        {
          text: "All",
          value: this.state.transLog.length,
        },
      ],
    };

    const optionsFault = {
      // pageStartIndex: 0,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: false,
      sizePerPageList: [
        {
          text: "5th",
          value: 5,
        },
        {
          text: "10th",
          value: 10,
        },
        {
          text: "All",
          value: this.state.faultLog.length,
        },
      ],
    };

    const selectRow = {
      mode: "checkbox",
      clickToSelect: false,
    };

    const start_click = (e) => {
      if (this.state.chargerStatus === "Offline") {
        this.props.warningToast({ title: "Warning", message: "Charger is Offline" });
        return;
      }

      if (this.state.chargerStatus !== "Charging") {
        this.setState({ isShowIdTagModal: true });
      }
      setTimeout(() => {
        if (this.state.chargerStatus !== "Charging") {
          this.setState({ startDisable: false });
        }
      }, 30000);
    };

    const stop_click = () => {
      //console.log("Stop Charge TransactionId", this.state.ActiveTransactionId);
      if (this.state.ActiveTransactionId === 0) {
        // alert("Not Authorized to stop this transaction");
        this.props.warningToast({ title: "Warning", message: "Not Authorized to stop this transaction" });
        return;
      }

      if (this.state.chargerStatus === "Offline") {
        // alert("Charge is Offline");
        this.props.warningToast({ title: "Warning", message: "Charger is Offline" });

        return;
      }
      console.log("Sending Stop");

      this.socketSend(getRequestTopic(this.state.chargerId), {
        type: "remoteStop",
        transactionId: Number(this.state.ActiveTransactionId),
      });
      this.setState({ startDisable: false });
    };

    const firmware_upgrade_click = () => {
      // if(firmwareUpgradeURL ==)
    };

    //let meter_value = 0.0;

    return (
      <React.Fragment>
        <div className="page-content">
          <ReactModal isOpen={this.state.isShowIdTagModal} onRequestClose={this.closeIsShowIdTagModal} style={modalStyle("50%", "50%")}>
            <div style={{ padding: "20px" }}>
              <div style={styles.modalHeader}>
                <div>
                  <h4 className="card-title">Id Tag (Mandatory)</h4>
                  <p className="card-title-desc">Fill all information below to start remote charge</p>
                </div>
                <h1>
                  <img src={LKCloseImg} alt="Close" style={styles.closeReactStrapModal} onClick={this.closeIsShowIdTagModal} />

                  {/* <i className="ri-close-line" style={styles.closeReactStrapModal} onClick={this.closeIsShowIdTagModal}></i> */}
                </h1>
              </div>

              <Row>
                <Col>
                  <FormGroup>
                    <Label htmlFor="chargerId">idTag*</Label>
                    <Input
                      id="idTag"
                      name="idTag"
                      type="text"
                      className="form-control"
                      placeholder="Enter idTag"
                      value={this.state.idTag}
                      onChange={(e) => this.setState({ idTag: e.target.value })}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <div className="d-flex justify-content-center mt-4">
                <ActiveBtn name={"Start Charge"} handleClick={this.handleIdTag} />

                <CancelBtn
                  name={"Cancel"}
                  handleClick={() => {
                    this.setState({ idTag: "" });
                    this.closeIsShowIdTagModal();
                  }}
                />
              </div>
            </div>
          </ReactModal>
          <Container fluid>
            <Breadcrumbs title="Charger Details" breadcrumbItems={this.state.breadcrumbItems} />

            <Row>
              <Col lg={12}>
                <Card>
                  <CardBody>
                    <Row>
                      <Col xl={5}>
                        <div className="product-detail">
                          <Row>
                            <Col md={8} xs={9}>
                              <TabContent activeTab={this.state.activeTab} id="v-pills-tabContent">
                                <TabPane tabId="1">
                                  <div className="product-img">
                                    <img
                                      src={this.state.imageMap[this.state.chargerDetails.imageId] || this.state.imgSrc}
                                      id="expandedImg1"
                                      style={{ height: 200 }}
                                      alt=""
                                      className="img-fluid mx-auto d-block"
                                    />
                                  </div>
                                </TabPane>
                                {/* <TabPane tabId="2">
                                  <div className="product-img">
                                    <img src={this.state.imgSrc} id="expandedImg2" alt="" className="img-fluid mx-auto d-block" />
                                  </div>
                                </TabPane>
                                <TabPane tabId="3">
                                  <div className="product-img">
                                    <img src={this.state.imgSrc} id="expandedImg3" alt="" className="img-fluid mx-auto d-block" />
                                  </div>
                                </TabPane>
                                <TabPane tabId="4">
                                  <div className="product-img">
                                    <img src={this.state.imgSrc} id="expandedImg4" alt="" className="img-fluid mx-auto d-block" />
                                  </div>
                                </TabPane> */}
                              </TabContent>
                              {/* {this.state.rating !== "3.3kW" && ( */}
                              <Row className="text-center mt-2">
                                <Col sm={6}>
                                  <Button
                                    onClick={start_click}
                                    disabled={this.state.chargerStatus === "Finishing" ? false : this.state.startDisable}
                                    style={{
                                      backgroundColor: this.state.start_btn_clr,
                                      color: this.state.start_btn_txt_clr,
                                    }}
                                    color="primary"
                                    block
                                    type="button"
                                    className="waves-effect waves-light mt-2 mr-1"
                                  >
                                    <i className="mdi mr-2"></i> Start Charge
                                  </Button>
                                </Col>
                                <Col sm={6}>
                                  <Button
                                    onClick={stop_click}
                                    style={{
                                      backgroundColor: this.state.stop_btn_clr,
                                      color: this.state.stop_btn_txt_clr,
                                    }}
                                    color="light"
                                    block
                                    type="button"
                                    className="btn-block waves-effect  mt-2 waves-light"
                                  >
                                    <i className="mdi mr-2"></i>Stop Charge
                                  </Button>
                                </Col>
                              </Row>
                              {/* )} */}
                              <br></br>

                              <div className="d-flex flex-column" style={{ width: "350px" }}>
                                <div className="d-flex  mb-2">
                                  <span style={{ minWidth: "150px" }}>
                                    <b>Ocpp Id</b>
                                  </span>
                                  <b style={styles.colonStyle}>:</b>
                                  <span style={styles.valueStyle}>{this.state.chargerDetails?.ocppId}</span>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                  <span style={{ minWidth: "150px" }}>
                                    <b>Transaction Id</b>
                                  </span>
                                  <b style={styles.colonStyle}>:</b>
                                  <span style={styles.valueStyle}>{this.state.ActiveTransactionId}</span>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                  <span style={{ minWidth: "150px" }}>
                                    <b>Consumption(in kWh)</b>
                                  </span>
                                  <b style={styles.colonStyle}>:</b>
                                  <span style={styles.valueStyle}>{this.state.consumption}</span>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col xl={7}>
                        <div className="mt-4 mt-xl-3">
                          <Link to="#" className="text-primary">
                            ID: {this.state.chargerId}
                          </Link>
                          <h4 className="font-size-15 font-bold mt-2">{this.state.chargerDetails?.name}</h4>
                          <p className="font-size-14">{this.state.chargerDetails?.rating} OCPP Charger</p>

                          {/* <div className="d-inline-flex">
                                                        <div className="text-muted mr-3">
                                                            <span className="mdi mdi-star text-warning mr-1"></span>
                                                            <span className="mdi mdi-star text-warning mr-1"></span>
                                                            <span className="mdi mdi-star text-warning mr-1"></span>
                                                            <span className="mdi mdi-star text-warning mr-1"></span>
                                                            <span className="mdi mdi-star mr-1"></span>
                                                        </div>
                                                        <div className="text-muted">( 132 )</div>
    </div>*/}

                          <h5 className="mt-2">
                            <span className={this.renderStatus()}>{this.state.chargerStatus}</span> <span className="text-danger font-size-12 ml-2"> {"<"} 5% Downtime</span>
                          </h5>
                          {/*<p className="mt-3">To achieve this, it would be necessary to have uniform pronunciation</p>*/}
                          <hr className="my-4" />

                          <Row>
                            <Col md={6}>
                              <div>
                                {/* <h5 className="font-size-14"><i className="mdi mdi-location"></i> Delivery location</h5>
                                                                <div className="form-inline">

                                                                    <InputGroup className="mb-3">
                                                                        <Input type="text" className="form-control" placeholder="Enter Delivery pincode " />
                                                                        <InputGroupAddon addonType="append">
                                                                            <Button color="light" type="button">Check</Button>
                                                                        </InputGroupAddon>
                                                                    </InputGroup>
                                                                </div> */}

                                <h5 className="font-size-14 d-flex align-items-center">
                                  Params
                                  {!isTechnician(this.state.user) && (
                                    <Link
                                      to="#"
                                      onClick={() =>
                                        this.setState({
                                          modal_static: true,
                                          isAlertOpen: false,
                                        })
                                      }
                                    >
                                      <img src={LKSettingImg} alt="lkSetting -img" style={{ width: "20px", height: "20px", marginLeft: "5px" }} />
                                    </Link>
                                  )}
                                </h5>
                                <div className="d-flex flex-column mb-4">
                                  {/* Last Heartbeat */}
                                  <div className="d-flex align-items-start mb-2">
                                    <span className="d-flex align-items-center" style={{ minWidth: "140px" }}>
                                      <img src={LKRefreshImg} alt="refresh" style={{ width: "16px", height: "16px", marginRight: "6px" }} />
                                      <b>Last Heartbeat</b>
                                    </span>
                                    <b style={{ width: "10px", textAlign: "center" }}>:</b>
                                    <span style={{ marginLeft: "8px", flex: 1 }}>{this.state.lasthb}</span>
                                  </div>

                                  {/* Unit Price (conditionally rendered) */}
                                  {!isTechnician(this.state.user) && (
                                    <div className="d-flex align-items-start mb-2">
                                      <span className="d-flex" style={{ minWidth: "140px" }}>
                                        <span
                                          style={{
                                            display: "inline-block",
                                            width: "16px",
                                            height: "16px",
                                            // fontWeight: "bold",
                                            fontSize: "16px",
                                            marginRight: "6px",
                                            color: "#005C8E",
                                            paddingBottom: "2px",
                                            paddingLeft: "2px",
                                          }}
                                        >
                                          ₹
                                        </span>
                                        <b>Unit Price</b>
                                      </span>
                                      <b style={{ width: "10px", textAlign: "center" }}>:</b>
                                      <span style={{ marginLeft: "8px", flex: 1 }}>
                                        {this.state.currency} {this.state.perUnitRate}
                                      </span>
                                    </div>
                                  )}

                                  {/* Firmware */}
                                  <div className="d-flex align-items-start mb-2">
                                    <span className="d-flex " style={{ minWidth: "140px" }}>
                                      <img src={LKFileImg} alt="firmware" style={{ width: "16px", height: "16px", marginRight: "6px" }} />
                                      <b>Firmware</b>
                                    </span>
                                    <b style={{ width: "10px", textAlign: "center" }}>:</b>
                                    <span style={{ marginLeft: "8px", flex: 1 }}>{this.state.firmwareVersion}</span>
                                  </div>
                                </div>
                              </div>
                            </Col>

                            <div>
                              <h5 className="font-size-14" style={{ height: "20px" }}>
                                Details :
                              </h5>
                              <div className="d-flex mb-2">
                                <span style={{ minWidth: "140px" }}>
                                  <i className="mdi mdi-circle-medium text-primary mr-1 align-middle font-size-16"></i>
                                  <b>Serial Number</b>
                                </span>
                                <b style={styles.colonStyle}>:</b>
                                <span style={styles.valueStyle}>{this.state.serialNumber}</span>
                              </div>
                              <div className="d-flex mb-2">
                                <span style={{ minWidth: "140px" }}>
                                  <i className="mdi mdi-circle-medium text-primary mr-1 align-middle font-size-16"></i>
                                  <b>Model</b>
                                </span>
                                <b style={styles.colonStyle}>:</b>
                                <span style={styles.valueStyle}>{this.state.modelType}</span>
                              </div>
                              <div className="d-flex mb-2">
                                <span style={{ minWidth: "140px" }}>
                                  <i className="mdi mdi-circle-medium text-primary mr-1 align-middle font-size-16"></i>
                                  <b>Protocol</b>
                                </span>
                                <b style={styles.colonStyle}>:</b>
                                <span style={styles.valueStyle}>{this.state.protocol}j</span>
                              </div>
                              {/* <ul className="list-unstyled product-desc-list">
                                <li>
                                  <i className="mdi mdi-circle-medium text-primary mr-1 align-middle font-size-16"></i> Serial Number: <b>{this.state.serialNumber}</b>
                                </li>
                                <li>
                                  <i className="mdi mdi-circle-medium text-primary mr-1 align-middle font-size-16"></i> Model: <b>{this.state.modelType}</b>
                                </li>
                                <li>
                                  <i className="mdi mdi-circle-medium text-primary mr-1 align-middle font-size-16"></i> Protocol: <b>{this.state.protocol}j</b>
                                </li>
                              </ul> */}
                            </div>
                          </Row>
                          <div className="d-flex flex-column mb-4 mt-2">
                            <div className="d-flex mb-2">
                              <span style={{ minWidth: "80px" }}>
                                <b>Connector</b>
                              </span>
                              <b style={styles.colonStyle}>:</b>
                              <span style={styles.valueStyle}>
                                {this.state.noOfConnectors}
                                {this.state.noOfConnectors > 0 && ` - ${this.state.connectors}`}
                              </span>
                            </div>
                            <div className="d-flex mb-2">
                              <span style={{ minWidth: "80px" }}>
                                <b>Address</b>
                              </span>
                              <b style={styles.colonStyle}>:</b>
                              <span style={styles.valueStyle}>{this.state.initialLocationDetails?.address}</span>
                            </div>
                          </div>

                          {/* <Row className="mb-1">
                            <Col>
                              <b>Connector : </b>
                              {this.state.noOfConnectors}
                              {this.state.noOfConnectors > 0 && `- ${this.state.connectors}`}
                            </Col>
                          </Row>
                          <Row className="mb-4">
                            <Col>
                              <b>Address:</b>
                            </Col>
                          </Row> */}
                          <h5 className="font-size-14">
                            <i className="mdi mdi-location"></i> Firmware Upgrade
                          </h5>
                          <div className="form-inline">
                            <InputGroup className="mb-3">
                              <Input type="text" className="form-control" placeholder="URL " onChange={this.firmwareInputChange} />
                              <InputGroupAddon addonType="append">
                                <Button color="light" type="button" onClick={() => this.firmware_upgrade_click()}>
                                  Upgrade
                                </Button>
                              </InputGroupAddon>
                            </InputGroup>
                            {this.state.showAlert && this.renderAlertMessage(this.state.alertMessage)}
                          </div>
                          <Row>
                            {/* <Col md={6}>
                                                            <div className="product-color mt-3">
                                                                <h5 className="font-size-14">Color :</h5>
                                                                <Link to="#" className="active">
                                                                    <div className="product-color-item">
                                                                        <img src={img1} alt="" className="avatar-md"/>
                                                                    </div>
                                                                    <p>Blue</p>
                                                                </Link>
                                                                <Link to="#" className="ml-1">
                                                                    <div className="product-color-item">
                                                                        <img src={img5} alt="" className="avatar-md"/>
                                                                    </div>
                                                                    <p>Cyan</p>
                                                                </Link>
                                                                <Link to="#" className="ml-1">
                                                                    <div className="product-color-item">
                                                                        <img src={img3} alt="" className="avatar-md"/>
                                                                    </div>
                                                                    <p>Green</p>
                                                                </Link>
                                                            </div>
                                                        </Col> 

                                                        <Col md={6}>
                                                            <div className="product-color mt-3">
                                                                <h5 className="font-size-14">Size :</h5>
                                                                <Link to="#" className="active ml-1">
                                                                    <div className="product-color-item">
                                                                        <div className="avatar-xs">
                                                                            <span className="avatar-title bg-transparent text-body">S</span>
                                                                        </div>
                                                                    </div>
                                                                    
                                                                </Link>
                                                                <Link to="#" className="ml-1">
                                                                    <div className="product-color-item">
                                                                        <div className="avatar-xs">
                                                                            <span className="avatar-title bg-transparent text-body">M</span>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                                <Link to="#" className="ml-1">
                                                                    <div className="product-color-item">
                                                                        <div className="avatar-xs">
                                                                            <span className="avatar-title bg-transparent text-body">L</span>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                                <Link to="#" className="ml-1">
                                                                    <div className="product-color-item">
                                                                        <div className="avatar-xs">
                                                                            <span className="avatar-title bg-transparent text-body">XL</span>
                                                                        </div>
                                                                    </div>
                                                                </Link>
                                                            </div>
                                                        </Col>*/}
                          </Row>
                        </div>
                      </Col>
                    </Row>

                    <div className="mt-4">
                      {/* <h5 className="font-size-14 mb-3"><b>Consumption(in kWh): {this.state.consumption}</b></h5> */}
                      <h5 className="font-size-14 mb-3">Logs: </h5>
                      {
                        <div className="product-desc">
                          <Nav tabs className="nav-tabs-custom" role="tablist">
                            {!isTechnician(this.state.user) && (
                              <NavItem>
                                <NavLink
                                  id="desc-tab"
                                  className={classnames({
                                    active: this.state.activeTab2 === "1",
                                  })}
                                  onClick={() => {
                                    this.toggleTab2("1");
                                  }}
                                >
                                  Transactions
                                </NavLink>
                              </NavItem>
                            )}
                            <NavItem>
                              <NavLink
                                id="specifi-tab"
                                className={classnames({
                                  active: this.state.activeTab2 === "2",
                                })}
                                onClick={() => {
                                  this.toggleTab2("2");
                                }}
                              >
                                Faults
                              </NavLink>
                            </NavItem>
                            <NavItem>
                              <NavLink
                                id="reservation-tab"
                                className={classnames({
                                  active: this.state.activeTab2 === "3",
                                })}
                                onClick={() => {
                                  this.toggleTab2("3");
                                }}
                              >
                                Reservation History
                              </NavLink>
                            </NavItem>
                          </Nav>
                          <TabContent activeTab={this.state.activeTab2} className="border border-top-0 p-4">
                            {!isTechnician(this.state.user) && (
                              <TabPane tabId="1" role="tabpanel">
                                {/* <div>
                                                            <p>If several languages coalesce, the grammar of the resulting language is more simple and regular than that of the individual </p>
                                                            <p>To achieve this, it would be necessary to have uniform grammar, pronunciation and more common several languages coalesce, the grammar of the resulting.</p>
                                                            <p>It will be as simple as occidental in fact.</p>

                                                            <div>
                                                                <p className="mb-2"><i className="mdi mdi-circle-medium mr-1 align-middle"></i> If several languages coalesce</p>
                                                                <p className="mb-2"><i className="mdi mdi-circle-medium mr-1 align-middle"></i> To an English person, it will seem like simplified</p>
                                                                <p className="mb-0"><i className="mdi mdi-circle-medium mr-1 align-middle"></i> These cases are perfectly simple.</p>
                                                            </div>
                                                    </div> */}
                                <BootstrapTable
                                  keyField="id"
                                  data={this.state.transLog}
                                  columns={LATEST_TRANSACTION_LOG_COLUMN_DATA}
                                  // expandRow={expandRow}
                                  pagination={paginationFactory(options)}
                                  // selectRow={selectRow}
                                />
                              </TabPane>
                            )}
                            <TabPane tabId="2" id="specifi" role="tabpanel">
                              <BootstrapTable
                                keyField="id"
                                data={this.state.faultLog}
                                columns={LATEST_FAULT_LOG_COLUMN_DATA}
                                // expandRow={expandRow}
                                pagination={paginationFactory(optionsFault)}
                                // selectRow={selectRow}
                              />
                            </TabPane>
                            <TabPane tabId="3" id="reservation-tab" role="tabpanel">
                              {this.state.reservationHistory?.length === 0 && <div>No reservation History</div>}
                              {/* <BootstrapTable
                                keyField="id"
                                data={this.state.faultLog}
                                columns={LATEST_FAULT_LOG_COLUMN_DATA}
                                // expandRow={expandRow}
                                pagination={paginationFactory(optionsFault)}
                                // selectRow={selectRow}
                              /> */}
                            </TabPane>
                          </TabContent>
                        </div>
                      }
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>

            <ReactModal isOpen={this.state.modal_static} style={modalStyle("60%", "75%")} onRequestClose={this.closeEditChargerModal} backdrop="static" centered size="lg">
              {/* <ModalHeader toggle={this.closeEditChargerModal}>
                <b>Edit Charger Params </b>
                (* Mandatory fields)
              </ModalHeader> */}
              <div className="d-flex justify-content-between align-items-center px-3 mt-2 pb-3 border-bottom">
                <h5 className="m-0"> Customer Details </h5>
                <img src={LKCloseImg} alt="Close" onClick={this.closeEditChargerModal} style={{ cursor: "pointer", width: "20px", height: "20px", marginLeft: "auto" }} />
              </div>
              <ModalBody>
                <AvForm onValidSubmit={this.addCustomer} model={location}>
                  <Row>
                    <Col lg={12}>
                      <Alert color="success" isOpen={this.state.isAlertOpen} toggle={() => this.setState({ isAlertOpen: false })}>
                        Data Added Successfully...!
                      </Alert>
                      <FormGroup>
                        <Label htmlFor="name">Charger Id</Label>
                        <AvField
                          name="chargerId"
                          type="text"
                          className="form-control text-muted"
                          id="chargerId"
                          placeholder="Enter Charger Id"
                          value={this.state.chargerId}
                          required
                          disabled
                          style={{ cursor: "not-allowed" }}
                        ></AvField>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={6}>
                      <FormGroup>
                        <Label htmlFor="number">Latitude</Label>
                        <AvField
                          name="lat"
                          type="text"
                          className="form-control text-muted"
                          id="loclat"
                          placeholder="Enter Latitude"
                          value={this.state.selectedLocationDetails.lat}
                          required
                          disabled
                          style={{ cursor: "not-allowed" }}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg={6}>
                      <FormGroup>
                        <Label htmlFor="email">Longitude</Label>
                        <AvField
                          name="lng"
                          type="text"
                          className="form-control text-muted"
                          id="loclong"
                          placeholder="Enter Longitude"
                          value={this.state.selectedLocationDetails.lng}
                          required
                          disabled
                          style={{ cursor: "not-allowed" }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={6}>
                      <FormGroup>
                        <Label htmlFor="number">Price{inputRequired()}</Label>
                        <AvField
                          name="lat"
                          type="number"
                          className="form-control"
                          id="loclat"
                          placeholder="Enter Price"
                          value={this.state.selectedPerUnitRate}
                          onChange={(e) => this.setState({ selectedPerUnitRate: e.target.value })}
                          required
                        />
                      </FormGroup>
                    </Col>

                    <Col lg={6}>
                      <FormGroup>
                        <Label htmlFor="email">Time-zone</Label>
                        <select id="timezone" name="timezone" type="text" className="form-control">
                          {/* <option>Coordinated Universal Time (UTC)</option> */}
                          <option>Indian Standard Time (UTC + 5:30)</option>
                          {/* <option>US/Pacific Standard Time (UTC - 8)</option>
                          <option>US/Mountian Standard Time (UTC - 7)</option>
                          <option>US/Central Standard Time (UTC - 6)</option>
                          <option>US/Eastern Standard Time (UTC - 6)</option>
                          <option>Mideast/Riyadh87 (UTC + 3:07)</option> */}
                        </select>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm={6}>
                      <FormGroup>
                        <Label htmlFor="metatitle">Location{inputRequired()}</Label>
                        <select
                          id="location"
                          name="location"
                          type="text"
                          className="form-control"
                          value={this.state.selectedLocationDetails?.id}
                          onChange={this.updateLocationDetails}
                        >
                          {this.state?.locationData?.map((item) => {
                            const { id, name } = item;
                            return (
                              <option key={id} value={id}>
                                {name}
                              </option>
                            );
                          })}
                        </select>
                      </FormGroup>
                    </Col>

                    <Col lg={6}>
                      <FormGroup>
                        <Label htmlFor="address">Address</Label>
                        <AvField
                          name="addr"
                          type="text"
                          className="form-control text-muted"
                          id="locaddr"
                          placeholder="Enter Address"
                          value={this.state.selectedLocationDetails.address}
                          disabled
                          style={{ cursor: "not-allowed" }}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <ModalFooter>
                    <CancelBtn name={"Cancel"} handleClick={this.closeEditChargerModal} />
                    <ActiveBtn name={"Update"} handleClick={this.updateChargersUnitAndLocationId} />
                  </ModalFooter>
                </AvForm>
              </ModalBody>
            </ReactModal>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedChargerId: state.ChargerManagement.selectedChargerId,
  locationIds: state.LocationManagement.locationIds,
  user: state.Login.user,
});
const mapDispatchToProps = (dispatch) => ({
  warningToast: (payload) => dispatch(warningToast(payload)),
  failureToast: (payload) => dispatch(failureToast(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ChargerDetail);

const styles = {
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "start",
    marginBottom: "20px",
  },
  closeReactStrapModal: { cursor: "Pointer", width: "20px", height: "20px", marginLeft: "auto" },
  colonStyle: { minWidth: "10px", textAlign: "center" },
  valueStyle: { marginLeft: "8px", flex: 1 },
};
